export class FrontendUserVerificationCodeModel {
  id?: number;
  email!: string;
  is_two_factor_verified!: any;
  two_factor_authentication_code!: string;
  created_at?: string;
  modified_at?: string;
}
